import { Box, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";

import type { ExtendedVisionUser } from "@thalamos/vision-common";

import { NotificationProvider } from "../../Context/NotificationContext.js";
import type { UserContextType } from "../../Context/UserContext.js";
import { AppDrawer } from "../AppDrawer/AppDrawer.js";
import { Notifications } from "../Notifications/Notifications.js";

export const MainLayout = ({
  user,
  refetchUser,
}: {
  user: ExtendedVisionUser;
  refetchUser: UserContextType["refetchUser"];
}) => {
  return (
    <Stack>
      <AppDrawer user={user}>
        <Box
          component="main"
          sx={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <NotificationProvider userId={user.id}>
            <Notifications user={user} refetchUser={refetchUser} />
            <Outlet />
          </NotificationProvider>
        </Box>
      </AppDrawer>
    </Stack>
  );
};
